const myProfileUrls = [
  {
    locales: [
      'en',
      'en-gb',
      'bg-bg',
      'zh-cn',
      'cs-cz',
      'fi-fi',
      'it-it',
      'ja-jp',
      'ko-kr',
      'pt-br',
      'ro-ro',
      'ru-ru',
      'sk-sk',
      'es-es',
      'tr-tr',
    ],
    ferryAccount: 'passenger-ferries/account',
    profile: 'my-profile',
    consent: 'consent-privacy',
    bookings: 'bookings',
  },
  {
    locales: ['da-dk'],
    ferryAccount: 'passagerfaerger/bruger',
    profile: 'min-profil',
    consent: 'samtykke-fortrolighed',
    bookings: 'bookinger',
  },
  {
    locales: ['nl-be', 'nl-nl'],
    ferryAccount: 'overtochten-passagiers/account',
    profile: 'mijn-profiel',
    consent: 'toestemming-privacy',
    bookings: 'boekingen',
  },
  {
    locales: ['et-ee'],
    ferryAccount: 'reisilaevad/konto',
    profile: 'minu-profiil',
    consent: 'nousolek-privaatsus',
    bookings: 'broneeringuid',
  },
  {
    locales: ['fr-be', 'fr-fr', 'fr-ma'],
    ferryAccount: 'ferries-passagers/compte',
    profile: 'mon-profil',
    consent: 'consentement-confidentialite',
    bookings: 'mes-reservations',
  },
  {
    locales: ['de-de'],
    ferryAccount: 'passagierfaehren/account',
    profile: 'mein-profil',
    consent: 'datenschutz-einverstandnis',
    bookings: 'buchungen',
  },
  {
    locales: ['lv-lv'],
    ferryAccount: 'pasazieru-pramji/konts',
    profile: 'mans-profils',
    consent: 'piekrisana-privatums',
    bookings: 'rezervacijas',
  },
  {
    locales: ['lt-lt'],
    ferryAccount: 'keleiviniai-keltai/paskyra',
    profile: 'mano-profilis',
    consent: 'sutikimai-ir-bendravimas',
    bookings: 'uzsakymai',
  },
  {
    locales: ['no-nb'],
    ferryAccount: 'ferge/konto',
    profile: 'min-profil',
    consent: 'samtykke-og-kommunikasjon',
    bookings: 'bestillinger',
  },
  {
    locales: ['pl-pl'],
    ferryAccount: 'promy-pasazerskie/konto',
    profile: 'moj-profil',
    consent: 'zgody-i-komunikacja',
    bookings: 'rezerwacje',
  },
  {
    locales: ['sv-se'],
    ferryAccount: 'passagerarfartyg/konto',
    profile: 'min-profil',
    consent: 'samtycke-integritet',
    bookings: 'bokningar',
  },
]

export default myProfileUrls
